import React from 'react'
import {
  ArrowRight,
  ArrowUpRight,
  BadgeCheck,
  BarChart3,
  Briefcase,
  Building2,
  Calendar,
  Check,
  ClipboardList,
  Clock,
  FileText,
  Globe,
  Handshake,
  HeartPulse,
  Landmark,
  LifeBuoy,
  Lightbulb,
  Lock,
  Mail,
  MapPin,
  MessageCircle,
  Phone,
  PiggyBank,
  Scale,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  Sparkles,
  Target,
  TrendingUp,
  Truck,
  Umbrella,
  Users,
  Zap,
  type LucideProps,
} from 'lucide-react'

/** Ícones (lucide) disponíveis no editor — lista fechada para o bundle não crescer. */
export const ICONES = {
  shield: Shield,
  shieldCheck: ShieldCheck,
  umbrella: Umbrella,
  briefcase: Briefcase,
  building: Building2,
  users: Users,
  handshake: Handshake,
  fileText: FileText,
  clipboard: ClipboardList,
  search: Search,
  target: Target,
  trendingUp: TrendingUp,
  barChart: BarChart3,
  piggyBank: PiggyBank,
  landmark: Landmark,
  scale: Scale,
  heartPulse: HeartPulse,
  lifeBuoy: LifeBuoy,
  lightbulb: Lightbulb,
  lock: Lock,
  settings: Settings,
  sparkles: Sparkles,
  zap: Zap,
  truck: Truck,
  globe: Globe,
  calendar: Calendar,
  clock: Clock,
  mail: Mail,
  phone: Phone,
  mapPin: MapPin,
  messageCircle: MessageCircle,
  badgeCheck: BadgeCheck,
  check: Check,
  arrowRight: ArrowRight,
  arrowUpRight: ArrowUpRight,
} as const

export type NomeIcone = keyof typeof ICONES

export const ICONE_OPTIONS: { label: string; value: NomeIcone }[] = [
  { label: 'Escudo', value: 'shield' },
  { label: 'Escudo com check', value: 'shieldCheck' },
  { label: 'Guarda-chuva', value: 'umbrella' },
  { label: 'Pasta (negócios)', value: 'briefcase' },
  { label: 'Prédio', value: 'building' },
  { label: 'Pessoas', value: 'users' },
  { label: 'Aperto de mãos', value: 'handshake' },
  { label: 'Documento', value: 'fileText' },
  { label: 'Prancheta', value: 'clipboard' },
  { label: 'Lupa', value: 'search' },
  { label: 'Alvo', value: 'target' },
  { label: 'Tendência', value: 'trendingUp' },
  { label: 'Gráfico', value: 'barChart' },
  { label: 'Cofrinho', value: 'piggyBank' },
  { label: 'Instituição', value: 'landmark' },
  { label: 'Balança', value: 'scale' },
  { label: 'Saúde', value: 'heartPulse' },
  { label: 'Boia (suporte)', value: 'lifeBuoy' },
  { label: 'Lâmpada', value: 'lightbulb' },
  { label: 'Cadeado', value: 'lock' },
  { label: 'Engrenagem', value: 'settings' },
  { label: 'Brilhos', value: 'sparkles' },
  { label: 'Raio', value: 'zap' },
  { label: 'Caminhão', value: 'truck' },
  { label: 'Globo', value: 'globe' },
  { label: 'Calendário', value: 'calendar' },
  { label: 'Relógio', value: 'clock' },
  { label: 'E-mail', value: 'mail' },
  { label: 'Telefone', value: 'phone' },
  { label: 'Localização', value: 'mapPin' },
  { label: 'Mensagem', value: 'messageCircle' },
  { label: 'Selo verificado', value: 'badgeCheck' },
  { label: 'Check', value: 'check' },
  { label: 'Seta direita', value: 'arrowRight' },
  { label: 'Seta diagonal', value: 'arrowUpRight' },
]

export function Icone({
  nome,
  fallback = 'shield',
  ...props
}: { nome: string | null | undefined; fallback?: NomeIcone } & LucideProps) {
  const Comp = (nome && nome in ICONES ? ICONES[nome as NomeIcone] : ICONES[fallback]) ?? Shield
  return <Comp strokeWidth={1.5} aria-hidden {...props} />
}
